import { useState, useEffect } from "react";
import { ANIMATIONS } from "./utils/theme";
import { loadUser, saveUser, saveToken, clearUser } from "./utils/data";
import { authAPI } from "./utils/api";
import { Home, AdminLogin, StudentLogin } from "./pages/auth/AuthPages";
import Layout from "./components/Layout";
import { AdminDashboard, AdminDegrees, AdminCourses, AdminModules,
  AdminStudents, AdminFees, AdminAssignments, AdminExams,
  AdminGrades, AdminAnnouncements, AdminReapply } from "./pages/admin/AdminPages";
import AdminQA from "./pages/admin/QA";
import { StudentDashboard, StudentCourses, StudentLectures,
  StudentAssignments, StudentExams, StudentGrades,
  StudentAnnouncements, StudentControlPanel } from "./pages/student/StudentPages";
import StudentQA from "./pages/student/QA";
import Games from "./pages/student/Games";

function getRoute() {
  const p = window.location.pathname;
  if (p === "/admin-login") return "admin-login";
  if (p === "/student-login" || p === "/") return "student-login";
  return "home";
}

export default function App() {
  const [route, setRoute] = useState(getRoute);
  const [user, setUser] = useState(loadUser);
  const [data, setData] = useState({
    users: [], degrees: [], programs: [], courses: [],
    modules: [], lectures: [], assignments: [], exams: [],
    submissions: [], examResults: [], announcements: [],
    qaThreads: [], notifications: [],
  });
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState("dashboard");

  window.onpopstate = () => { if (!user) setRoute(getRoute()); };

  const handleLogin = async (u, token) => {
    saveUser(u);
    saveToken(token);
    setUser(u);
    setPage("dashboard");
    window.history.pushState({}, "", "/");
  };

  const handleLogout = () => {
    clearUser();
    setUser(null);
    setRoute("home");
    window.history.pushState({}, "", "/");
  };

  if (!user) {
    if (route === "admin-login") return (
      <><style>{ANIMATIONS}</style>
        <AdminLogin onLogin={handleLogin} setRoute={setRoute} />
      </>
    );
    if (route === "student-login") return (
      <><style>{ANIMATIONS}</style>
        <StudentLogin onLogin={handleLogin} setRoute={setRoute} />
      </>
    );
    return (
      <><style>{ANIMATIONS}</style>
        <Home setRoute={setRoute} />
      </>
    );
  }

  const adminPages = {
    dashboard:     <AdminDashboard user={user} />,
    degrees:       <AdminDegrees />,
    courses:       <AdminCourses />,
    modules:       <AdminModules />,
    students:      <AdminStudents />,
    fees:          <AdminFees />,
    assignments:   <AdminAssignments />,
    exams:         <AdminExams />,
    grades:        <AdminGrades />,
    announcements: <AdminAnnouncements />,
    qa_admin:      <AdminQA />,
    reapply_admin: <AdminReapply />,
  };

  const studentPages = {
    dashboard:       <StudentDashboard user={user} setPage={setPage} />,
    my_courses:      <StudentCourses user={user} />,
    lectures_s:      <StudentLectures user={user} />,
    assignments_s:   <StudentAssignments user={user} />,
    exams_s:         <StudentExams user={user} />,
    grades_s:        <StudentGrades user={user} />,
    announcements_s: <StudentAnnouncements />,
    qa_s:            <StudentQA user={user} />,
    games:           <Games />,
    control_panel:   <StudentControlPanel user={user} />,
  };

  const pages = user.role === "admin" ? adminPages : studentPages;

  return (
    <>
      <style>{ANIMATIONS}</style>
      <Layout user={user} onLogout={handleLogout} page={page} setPage={setPage}>
        {pages[page] || pages["dashboard"]}
      </Layout>
    </>
  );
}